<template>
  <div class="Box">
    <div class="title_top">
      <span class="title_top_span">{{ $t('collectionCenter.mis7') }}</span><!-- 错发路径配置 -->
      <span>
        <el-button size="small" @click="exportAll">{{ $t('collectionCenter.export') }}</el-button><!-- 导出 -->
        <el-button
          type="primary" size="small" class="blue_color_btn"
          @click="open('',3)"
        >{{ $t('collectionCenter.addRule') }}</el-button><!-- 新增规则 -->
      </span>
    </div>
    <el-card style="margin: 20px 0; border-radius: 10px; box-sizing: border-box">
      <div slot="header" class="position_box">
        <span style="font-size: 15px;font-weight: bold">{{ $t('collectionCenter.searchConditions') }}</span><!-- 查询条件 -->
        <div class="qipao_box">
          <span class="qipao_msg">{{ $t('collectionCenter.configInstructions') }}</span><!-- 配置说明 ？ -->
          <span class="qipao_class">{{ $t('collectionCenter.misroutingRuleDescription') }}</span>
        </div>
      </div>
      <el-form class="form_box">
        <el-row
          type="flex" justify="left" :gutter="20"
          style="flex-wrap: wrap"
        >
          <!-- 规则名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.mis4')">
              <el-input
                v-model="queryForm.params.ruleName" :placeholder="$t('collectionCenter.ruleNamePlaceholder')"
                clearable style="width: 100%" size="medium"
              />
            </el-form-item>
          </el-col>
          <!-- 始发转运中心 -->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.mis1')">
              <ElSelectV2
                v-model="queryForm.params.originHubIds"
                :options="siteList"
                :placeholder="$t('collectionCenter.originTransitCenterPlaceholder')"
                clearable filterable multiple
                collapse-tags
                style="width: 100%" size="medium"
                popper-class="SelectV2_popper"
              />
            </el-form-item>
          </el-col>
          <!-- 途径转运中心 -->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.mis5')">
              <ElSelectV2
                v-model="queryForm.params.transitHubIds"
                :options="siteList"
                :placeholder="$t('collectionCenter.intermediateCenterPlaceholder')"
                clearable filterable multiple
                collapse-tags
                style="width: 100%" size="medium"
                popper-class="SelectV2_popper"
              />
            </el-form-item>
          </el-col>
          <!-- 预派送网点 -->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.mis6')">
              <ElSelectV2
                v-model="queryForm.params.deliverySiteIds"
                :options="allSiteList"
                :placeholder="$t('collectionCenter.siteName')"
                clearable filterable multiple
                collapse-tags
                style="width: 100%" size="medium"
                popper-class="SelectV2_popper"
              />
            </el-form-item>
          </el-col>
          <!-- 状态 -->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.stateZT')">
              <el-select
                v-model="queryForm.params.status"
                :placeholder="$t('GlobalSetObj.all')"
                clearable style="width: 100%" size="medium"
              >
                <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
                <el-option :label="$t('GlobalSetObj.stop')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="padding-top: 40px">
            <el-button type="primary" class="blue_color_btn" @click="getData(1)">
              {{ $t('collectionCenter.search') }}
            </el-button>
            <el-button class="default_btn" @click="defaultForm">{{ $t('collectionCenter.reset') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="border-radius: 10px; box-sizing: border-box">
      <el-table
        :data="tableData" border max-height="600"
        :header-cell-style="{background:'#f8fafd',color:'#536178','font-weight': 600, 'border-bottom': 'none'}"
      >
        <!-- 创建时间 -->
        <el-table-column
          :label="$t('collectionCenter.CreationTime')" prop="createTime" align="center"
          width="100"
        />
        <!-- 规则名称 -->
        <el-table-column
          :label="$t('GlobalSetObj.RuleName')" prop="ruleName" align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;color: #1f2937">{{ scope.row.ruleName }}</div>
            <!--            <div style="font-size: 12px;color: #8a96a8">{{ scope.row.xxx2_1 }}===</div>-->
          </template>
        </el-table-column>
        <!-- 始发转运中心 -->
        <el-table-column
          :label="$t('collectionCenter.mis1')" prop="originHubName" align="center"
          width="150"
        />
        <!-- 完整允许路径 -->
        <el-table-column
          :label="$t('collectionCenter.mis2')" align="center"
          :width="getRouteColumnWidth()" class="route_container"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.originHubName || (scope.row.transitHubNames && scope.row.transitHubNames.length) || (scope.row.deliverySiteNamesList && scope.row.deliverySiteNamesList.length)">
              <!-- 第一部分：始发转运中心 -->
              <template v-if="scope.row.originHubName">
                <span class="tag_route tag-first">{{ scope.row.originHubName }}</span>
                <span v-if="(scope.row.transitHubNames && scope.row.transitHubNames.length) || (scope.row.deliverySiteNamesList && scope.row.deliverySiteNamesList.length)" class="arrow_separator">→</span>
              </template>

              <!-- 第二部分：途径转运中心 -->
              <template v-if="scope.row.transitHubNames && scope.row.transitHubNames.length">
                <template v-for="(item, index) in scope.row.transitHubNames">
                  <span :key="'transit-' + index" class="tag_route tag-middle">{{ item }}</span>
                  <!-- 箭头 -->
                  <span
                    v-if="index < scope.row.transitHubNames.length - 1"
                    :key="'transit-arrow-' + index"
                    class="arrow_separator"
                  >→</span>
                </template>
                <!-- 箭头 -->
                <span v-if="scope.row.deliverySiteNamesList && scope.row.deliverySiteNamesList.length" class="arrow_separator">→</span>
              </template>

              <!-- 第三部分：预派送网点 -->
              <template v-if="scope.row.deliverySiteNamesList && scope.row.deliverySiteNamesList.length">
                <template v-for="(item, index) in scope.row.deliverySiteNamesList">
                  <span :key="'delivery-' + index" class="tag_route tag-last">{{ item }}</span>
                  <!-- 箭头 -->
                  <span
                    v-if="index < scope.row.deliverySiteNamesList.length - 1"
                    :key="'delivery-arrow-' + index"
                    class="arrow_separator"
                  >→</span>
                </template>
              </template>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <!-- 覆盖预派送网点 -->
        <el-table-column
          :label="$t('collectionCenter.mis3')" prop="deliverySiteCount" align="center"
          width="200"
        >
          <template slot-scope="scope">
            <span class="site_total">{{ $t('collectionCenter.mis19') }} {{ scope.row.deliverySiteCount }} {{ $t('collectionCenter.mis21') }}</span>
            <br>
            <el-tooltip
              class="item" effect="dark" :content="scope.row.deliverySiteNamesVal"
              placement="top-start"
            >
              <span class="site_names">{{ scope.row.deliverySiteNamesVal }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column :label="$t('collectionCenter.stateZT')" prop="status" align="center">
          <template slot-scope="scope">
            <span class="state_class" :class="scope.row.status === 1 ? 'green' : 'red'">
              {{ scope.row.status === 1 ? $t('GlobalSetObj.enable') : scope.row.status === 0 ? $t('GlobalSetObj.stop') : '' }}
            </span>
          </template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column :label="$t('collectionCenter.creator')" prop="createBy" align="center" />
        <!-- 更新时间 -->
        <el-table-column
          :label="$t('GlobalSetObj.UpdateTime')" prop="updateTime" align="center"
          width="100"
        />
        <!-- 更新人 -->
        <el-table-column
          :label="$t('GlobalSetObj.Updater')" prop="updateBy" align="center"
          width="150"
        />
        <!-- 操作 -->
        <el-table-column
          :label="$t('jobManagement.operation')" fixed="right" width="130"
          align="center"
        >
          <template slot-scope="scope">
            <div class="operation_btn">
              <!-- 查看 -->
              <span @click.stop="open(scope.row, 1)">{{ $t('collectionCenter.View') }}</span>
              <!-- 编辑 -->
              <span @click.stop="open(scope.row, 2)">{{ $t('collectionCenter.edit') }}</span>
              <!-- 停用 / 启用 -->
              <!-- 你确认要停用吗？/ 你确认要启用吗？ -->
              <el-popconfirm
                :title="scope.row.status === 1 ? $t('collectionCenter.mis24') : $t('collectionCenter.mis25')"
                @confirm="changeStatus(scope.row)"
              >
                <span slot="reference">{{ scope.row.status === 1 ? $t('collectionCenter.Disable') : $t('collectionCenter.enable') }}</span>
              </el-popconfirm>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getData"
          @size-change="getData(1)"
        />
      </div>
    </el-card>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="misTitle"
      :visible.sync="showMisDialog"
      width="70%"
      @close="misClose"
    >
      <misDialog
        ref="misDialogRef"
        :mis-title="misTitle" :site-list-val="misTitle === $t('collectionCenter.mis11') ? siteList : siteStatusList"
        :delivery-site="misTitle === $t('collectionCenter.mis11') ? viewSiteData : siteData"
        @mis-close="misClose" @to-search="getData"
      />
    </el-dialog>
  </div>
</template>

<script>
import ElSelectV2 from 'el-select-v2';
import {
  routeDeviationPathConfigPage,
  getTransitCenterAll,
  routeDeviationPathConfigView,
  routeDeviationPathConfigStatus,
  getSiteAll,
  routeDeviationPathConfigExport,
  getSiteStatusPart,
  getRegionStatusPart
} from '@/api/lanshou';
import { getRegionOptions } from '@/api/orderApi';
import { goRWExportList } from '@/utils/goExportList';

export default {
  components: {
    ElSelectV2,
    'misDialog': () => import('./misDialog.vue')
  },
  data() {
    return {
      siteStatusList: [], // 新增/编辑 窗口单独调用接口
      siteList: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          ruleName: '',
          originHubIds: [],
          transitHubIds: [],
          deliverySiteIds: [],
          status: null
        }
      },
      total: 0,
      tableData: [],
      showMisDialog: false,
      misTitle: '',
      misData: {},
      siteData: [],
      viewSiteData: [],
      allSiteList: [] // 预派送网点
    };
  },
  created() {
    this.defaultForm();
    this.getSiteData();
    this.getViewSiteCascader();
    this.getAllSite();
    this.getSiteCascader();
    this.getSiteStatusData();
  },
  methods: {
    exportAll() {
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('operationCenter.noDataExported')); // 列表暂无数据，无法导出
        return;
      }
      routeDeviationPathConfigExport(this.queryForm.params).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    defaultForm() {
      this.queryForm.params = {
        ruleName: '',
        originHubIds: [],
        transitHubIds: [],
        deliverySiteIds: [],
        status: null
      };
      this.getData(1);
    },
    getData(pageNumber = 1) {
      if (pageNumber) {
        this.queryForm.pageNumber = pageNumber;
      }
      this.queryForm.params.status = this.queryForm.params.status !== '' ? this.queryForm.params.status : null;
      routeDeviationPathConfigPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableData = res.data.records.map(item => {
            item.deliverySiteNamesList = item.deliverySiteNames;
            item.deliverySiteNamesVal = item.deliverySiteNames.join('、');
            return item;
          });
        }
      });
    },
    getSiteData() {
      getTransitCenterAll().then(res => {
        if (res.code === 200) {
          this.siteList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    },
    getSiteStatusData() {
      getSiteStatusPart().then(res => {
        if (res.code === 200) {
          this.siteStatusList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    },
    // 预派送网点———— 查所有网点（仅查网点数据）
    getAllSite() {
      getSiteAll().then(res => {
        if (res.code === 200) {
          this.allSiteList = (res.data || []).map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });
        }
      });
    },
    // 完整允许路径————计算列宽
    getRouteColumnWidth() {
      let maxWidth = 150; // 最小宽度

      this.tableData.forEach(row => {
        if (row.fullPath && row.fullPath.length) {
          // 计算所有标签+箭头+间距的总长度
          const totalText = row.fullPath;
          const estimatedWidth = totalText.length * 12 + 50;
          if (estimatedWidth > maxWidth) {
            maxWidth = estimatedWidth;
          }
        }
      });
      return maxWidth;
    },
    // 新增 / 编辑路径规则
    async open(row, type) {
      this.misData = {
        ruleName: '',
        originHubId: null,
        transitHubIds: [],
        deliverySiteIds: [],
        status: null
      };
      if (type === 1) {
        // 查看
        this.misTitle = this.$t('collectionCenter.mis11');
        routeDeviationPathConfigView(row.id).then(async res => {
          if (res.code === 200) {
            this.misData = {
              ruleName: res.data.ruleName,
              originHubId: res.data.originHubId,
              transitHubIds: res.data.transitHubIds,
              deliverySiteIds: res.data.deliverySiteIds,
              status: res.data.status
            };
            await this.getViewSiteCascader();
            await this.getSiteData();
            this.showMisDialog = true;
            this.$nextTick(() => {
              this.$refs.misDialogRef.assign(this.misData);
            });
          }
        });
      } else if (type === 2) {
        // 编辑
        await Promise.all([this.getSiteCascader(), this.getSiteStatusData()]);
        this.misTitle = this.$t('collectionCenter.mis10');
        this.misData = {
          id: row.id,
          ruleName: row.ruleName,
          originHubId: row.originHubId,
          transitHubIds: row.transitHubIds,
          deliverySiteIds: row.deliverySiteIds,
          status: row.status
        };
        this.showMisDialog = true;
        this.$nextTick(() => {
          this.$refs.misDialogRef.assign(this.misData);
        });
      } else if (type === 3) {
        // 新增规则
        await Promise.all([this.getSiteCascader(), this.getSiteStatusData()]);
        this.misTitle = this.$t('collectionCenter.mis9');
        this.showMisDialog = true;
        this.$nextTick(() => {
          this.$refs.misDialogRef.assign(this.misData);
        });
      }
    },
    misClose() {
      this.showMisDialog = false;
      this.$refs.misDialogRef.clearForm();
    },
    changeStatus(row) {
      const statusForm = {
        id: row.id,
        status: row.status === 1 ? 0 : 1
      };
      routeDeviationPathConfigStatus(statusForm).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.getData();
        }
      });
    },

    getViewSiteCascader() {
      getRegionOptions().then(res => {
        if (res.code === 200) {
          const siteData = res.data.map((item) => {
            const value = item.id;
            const label = this.$i18n.locale === 'zh' ? item.zhName : item.puName;
            let children = [];
            if (item.sites) {
              children = item.sites.map((itm) => {
                return {
                  label: itm.name,
                  value: itm.id,
                  state: itm.state
                };
              });
            }
            return {
              value,
              label,
              children
            };
          });
          this.viewSiteData = siteData;
        }
      });
    },

    getSiteCascader() {
      getRegionStatusPart().then(res => {
        if (res.code === 200) {
          const siteData = res.data.map((item) => {
            const value = item.id;
            const label = this.$i18n.locale === 'zh' ? item.zhName : item.puName;
            let children = [];
            if (item.sites) {
              children = item.sites.map((itm) => {
                return {
                  label: itm.name,
                  value: itm.id,
                  state: itm.state
                };
              });
            }
            return {
              value,
              label,
              children
            };
          });
          this.siteData = siteData;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{ grid-template-rows: auto 1fr auto;min-height: 100%;background: #f4f6fa;padding: 20px;box-sizing: border-box; }

.position_box { position: relative; }
.qipao_box {float: right;position: relative;display: inline-block;cursor: default;}
.qipao_msg {color: #2f63e6;font-size: 13px;font-weight: bold;}
.position_box:hover .qipao_box:hover .qipao_class {display: inline-block;}
.qipao_class {
  display: none;
  position: absolute;right: 0;top: 100%;width: 400px;border: 1px solid #b7cdfd;background: #fff;
  z-index: 10;padding: 10px;border-radius: 10px;box-sizing: border-box;font-size: 13px;color: #3154a4;
}
.title_top { display: flex;justify-content: space-between;align-items: center; }
.title_top_span { font-size: 23px;font-weight: bold; }
.SelectV2_popper { width: 170px; }

.blue_color_btn { background: #2f63e6;border-color: #2f63e6;border-radius: 8px;padding: 10px 17px;box-sizing: border-box; }
.default_btn { border-radius: 8px;padding: 10px 17px;box-sizing: border-box; }

.operation_btn { cursor: pointer; gap: 10px; display: flex;justify-content: space-between;align-items: center; }
.operation_btn span { white-space: nowrap;color: #2f63e6;font-weight: bold; }

.route_container ::v-deep .cell { overflow: visible; }
.tag_route {
  flex-shrink: 0;padding: 3px 10px;border-radius: 16px;border: 1px solid;
  font-size: 13px;font-weight: bold;white-space: nowrap;margin: 5px 0;display: inline-block;box-sizing: border-box;
}
/* 第一个标签 - 橙色系 */
.tag-first { border-color: #ffd1a8;background-color: #fff3e7;color: #d65a16; }
/* 中间标签 - 绿色系 */
.tag-middle { border-color: #beeccd;background-color: #eafaf1;color: #19a65a; }
/* 最后一个标签 - 紫色系 */
.tag-last { border-color: #ddd0ff;background-color: #f3edff;color: #7c3aed; }
.arrow_separator { color: #bbb;font-weight: 300;flex-shrink: 0;margin: 0 2px; }

.site_total {
  background: #eaf2ff;color: #2f63e6;display: inline-block;padding: 3px 10px;border-radius: 16px;box-sizing: border-box;
  font-size: 13px;font-weight: bold;white-space: nowrap;margin-bottom: 5px;
}
.site_names {
  font-size: 12px;color: #8a96a8;white-space: nowrap;width: 100%;text-overflow: ellipsis;overflow: hidden;
}
.state_class {
  display: inline-block;padding: 3px 10px;border-radius: 16px;box-sizing: border-box;
  font-size: 13px;font-weight: bold;
}
.state_class.green { background: #d8f8e5;color: #12934d; }
.state_class.red { background: #f8d8d8;color: #c31818; }

.form_box ::v-deep .el-form-item { margin-bottom: 10px !important; }
</style>
